export default "__VITE_ASSET__D2ZX4NR2__"